import { assert } from "@/core";

import { Http } from "./http.init";

export class BaseService {
  constructor(entity) {
    this.entity = entity || "";
  }

  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  request(config = { auth: false }) {
    return new Http(config);
  }

  /**
   * ------------------------------
   * @API_CALLS_PUBLIC
   * ------------------------------
   */

  async getListPublic(parameters = {}) {
    assert.object(parameters);

    const response = await this.request().get(`${this.entity}`, {
      params: parameters
    });
    return response.data;
  }

  async getByIdPublic(id = window.required()) {
    assert.id(id, { required: true });

    const response = await this.request().get(`${this.entity}/${id}`);
    return response.data;
  }

  /**
   * ------------------------------
   * @API_CALLS_PRIVATE
   * ------------------------------
   */

  async getById(id) {
    assert.id(id, { required: true });
    const response = await this.request({ auth: true }).get(
      `${this.entity}/${id}`
    );
    return response.data;
  }

  async getList(parameters = {}) {
    assert.object(parameters);

    const response = await this.request({ auth: true }).get(`${this.entity}`, {
      params: parameters
    });
    return response.data;
  }

  async create(data = {}) {
    assert.object(data, { required: true });

    const response = await this.request({ auth: true }).post(
      `${this.entity}`,
      data
    );
    return response.data;
  }

  async update(id, data = {}) {
    assert.id(id, { required: true });
    assert.object(data, { required: true });

    const response = await this.request({ auth: true }).put(
      `${this.entity}/${id}`,
      data
    );
    return response.data;
  }

  async delete(id) {
    assert.id(id, { required: true });
    const response = await this.request({ auth: true }).delete(
      `${this.entity}/${id}`
    );
    return response.data;
  }
}
